/**
 * Time unit associated with the event.
 * tag: 1827
 * @readonly
 * @enum {string} (String)
 */
export enum EventTimeUnit {
  /** Hour */
  Hour = 'H',
  /** Minute */
  Minute = 'Min',
  /** Second */
  Second = 'S',
  /** Day */
  Day = 'D',
  /** Week */
  Week = 'Wk',
  /** Month */
  Month = 'Mo',
  /** Year */
  Year = 'Yr',
}
